export default {
    header: {
        company: "Cuprolli Manufacturing srl",
        vatId: "RO 35671874",
        regCom: "J2016000468359",
        address1: "Strada Caprioarei 11",
        address2: "307200 Ghiroda, Dép. Timis",
        address3: "Roumanie",
        email: "export@i-struct.eu",
        phone: "+40 748 179 927",
        website: "https://i-struct.fr",
        bankName: "Banca Transilvania",
        ibanNo: "RO89 BTRL EURC RT03 3757 8301",
        vatRate: "19%",
        validDays: "5"
    },
    dateFormat: "dd.MM.yyyy",
    labels: {
        proforma: "Facture proforma",
        proformaValidity: "Validité de la facture proforma",
        days: "Jours",
        from: "du",
        piece: "pcs",
        vatId: "TVA intra",
        regCom: "RCS",
        bank: "Banque",
        iban: "IBAN",
        client: "Client",
        mrMrs: "M./Mme",
        email: "E-mail",
        phone: "Tél",
        vatRate: "Taux de TVA",
        vatFree: "Exonéré de TVA",
        downPayment: "Acompte",
        accordingToOfferNo: "selon devis n°",
        no: "N°",
        productName: "Désignation du produit",
        qty: "Quantité",
        onePrice: "Prix unitaire",
        netAmount: "Montant net",
        subtotal: "Sous-total",
        woVat: "HT",
        vat: "TVA",
        total: "Montant total",
        note1: "* Autoliquidation",
        note2: "Inversion du redevable de la TVA"
    },
    messages: {
        endPageMessage: "Suite à la page suivante",
    }
}